import React, { useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { H3 } from "../Elements/Headings";
import CloseButton from "./CloseButton";
import theme from "../../theme";

const FixedWrapper = styled.div`
  width: 100%;
  position: fixed;
  overflow-y: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 9;
`;

const Centered = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  box-shadow: 2px 2px 10px 0px ${({ theme }) => theme.colors.shadow};
  height: 100%;
  width: 100%;
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : "auto")};
  @media (min-width: 768px) {
    height: auto;
    max-height: 85vh;
    margin: 0 10px;
    overflow: hidden;
    border-radius: 3px;
  }
`;

const Header = styled.div`
  background: ${({ theme }) => theme.colors.primaryBlue};
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  fill: white;
  padding: 20px;
  ${({ variant }) => variant && variants[variant].header}
`;

const Body = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
`;

const Footer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  padding: 20px;
  background: white;

  @media (min-width: 768px) {
    position: static;
    bottom: auto;
  }
`;

const variants = {
  blue: {
    header: css`
      background: ${({ theme }) => theme.colors.primaryBlue};
      color: white;
      fill: white;
    `,
    closeButton: "#FFFFFF",
  },
  light: {
    header: css`
      background: white;
      color: ${({ theme }) => theme.colors.default};
      border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    `,
    closeButton: theme.colors.default,
  },
};

export default function Modal({
  footer,
  title,
  children,
  close,
  variant,
  maxWidth = "900px",
}) {
  const modalWrapper = useRef(null);
  useEffect(() => {
    const clickOffClose = e => {
      if (e.target === modalWrapper.current) {
        close();
      }
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("click", clickOffClose);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("click", clickOffClose);
    };
  }, [close]);
  return (
    <FixedWrapper>
      <Centered ref={modalWrapper}>
        <Wrapper maxWidth={maxWidth}>
          {title && (
            <Header variant={variant}>
              <H3>{title}</H3>
              <CloseButton
                fill={variant && variants[variant].closeButton}
                close={close}
                width="15px"
                height="15px"
              />
            </Header>
          )}
          <Body>{children}</Body>
          {footer && <Footer>{footer}</Footer>}
        </Wrapper>
      </Centered>
    </FixedWrapper>
  );
}
